import Vue from 'vue';
import filters from './filters';
import './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css';
import Vuetify from 'vuetify';
import VueCurrencyFilter from 'vue-currency-filter';
import VueLazyload from 'vue-lazyload';
import VueAnalytics from 'vue-analytics';
import LogRocket from 'logrocket';

import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';

import InfiniteLoading from 'vue-infinite-loading';
import auth from './auth';
import App from './App.vue';

import './components';

import VueCompositionAPI from '@vue/composition-api';
import apolloProvider from './apollo-config';
import router from './router';
import { store } from './store';
import houseIcon from './components/icons/houseIcon.vue';
import targetIcon from './components/icons/targetIcon.vue';
import openBookIcon from './components/icons/openBookIcon.vue';
import userCardIcon from './components/icons/userCardIcon.vue';
import blockIcon from './components/icons/blockIcon.vue';
import doneIcon from './components/icons/doneIcon.vue';
import alertIcon from './components/icons/alertIcon.vue';
import searchIcon from './components/icons/searchIcon.vue';
import sendIcon from './components/icons/sendIcon.vue';
import winkIcon from './components/icons/winkIcon.vue';
import heartEyesIcon from './components/icons/heartEyesIcon.vue';
import sparklesIcon from './components/icons/sparklesIcon.vue';
import gearCheckIcon from './components/icons/gearCheckIcon.vue';
import exclamationCircleIcon from './components/icons/exclamationCircleIcon.vue';
import userIcon from './components/icons/userIcon.vue';
import moneyBagIcon from './components/icons/moneyBagIcon.vue';
import arrowRightIcon from './components/icons/arrowRightIcon.vue';
import arrowLeftIcon from './components/icons/arrowLeftIcon.vue';
import arrowDownIcon from './components/icons/arrowDownIcon.vue';
import phoneIcon from './components/icons/phoneIcon.vue';
import nophoneIcon from './components/icons/nophoneIcon.vue';
import mailIcon from './components/icons/mailIcon.vue';
import cpfIcon from './components/icons/cpfIcon.vue';
import cakeIcon from './components/icons/cakeIcon.vue';
import cartIcon from './components/icons/cartIcon.vue';
import moneyCircleIcon from './components/icons/moneyCircleIcon.vue';
import heartIcon from './components/icons/heartIcon.vue';
import giftIcon from './components/icons/giftIcon.vue';
import clockIcon from './components/icons/clockIcon.vue';
import deleteIcon from './components/icons/deleteIcon.vue';
import scaredEmojiIcon from './components/icons/scaredEmojiIcon.vue';
import arrowSwapIcon from './components/icons/arrowSwapIcon.vue';
import signOutIcon from './components/icons/signOutIcon.vue';
import zipperLogoIcon from './components/icons/zipperLogoIcon.vue';
import crmLogoIcon from './components/icons/crmLogoIcon.vue';
import shoppingBagIcon from './components/icons/shoppingBagIcon.vue';
import userPlusIcon from './components/icons/userPlusIcon.vue';
import unionIcon from './components/icons/unionIcon.vue';
import editIcon from './components/icons/editIcon.vue';
import atSignIcon from './components/icons/atSignIcon.vue';
import pIcon from './components/icons/pIcon.vue';
import barCodeIcon from './components/icons/barCodeIcon.vue';
import bagIcon from './components/icons/bagIcon.vue';
import passwordLockIcon from './components/icons/passwordLockIcon.vue';
import localActivityIcon from './components/icons/localActivityIcon.vue';
import storeIcon from './components/icons/storeIcon.vue';
import catalogueIcon from './components/icons/catalogueIcon.vue';
import catalogueThinIcon from './components/icons/catalogueThinIcon.vue';
import heartOutlineIcon from './components/icons/heartOutlineIcon.vue';
import checkIcon from './components/icons/checkIcon.vue';
import basketIcon from './components/icons/basketIcon.vue';

Vue.use(VueCompositionAPI);

Sentry.init({
  dsn: 'https://e40e1a34dc264ddd92cd6ac4bb8d9861@o449100.ingest.sentry.io/5431481',
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],
  tracesSampleRate: 1,
});

Vue.use(filters);
Vue.use(VueAnalytics, {
  id: 'UA-145388877-1',
  router,
  debug: {
    sendHitTask: window.location.hostname !== 'localhost',
  },
});
Vue.component('InfiniteLoading', InfiniteLoading);

Vue.use(VueLazyload, {
  lazyComponent: true,
});

Vue.use(VueCurrencyFilter,
  {
    symbol: 'R$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true,
  });

Vue.use(auth);
Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme: {
    primary: '#140C22',
  },
  icons: {
    userCardIcon: { // name of our custom icon
      component: userCardIcon, // our custom component
    },
    houseIcon: {
      component: houseIcon,
    },
    targetIcon: {
      component: targetIcon,
    },
    openBookIcon: {
      component: openBookIcon,
    },
    blockIcon: {
      component: blockIcon,
    },
    doneIcon: {
      component: doneIcon,
    },
    alertIcon: {
      component: alertIcon,
    },
    searchIcon: {
      component: searchIcon,
    },
    sendIcon: {
      component: sendIcon,
    },
    winkIcon: {
      component: winkIcon,
    },
    heartEyesIcon: {
      component: heartEyesIcon,
    },
    sparklesIcon: {
      component: sparklesIcon,
    },
    gearCheckIcon: {
      component: gearCheckIcon,
    },
    exclamationCircleIcon: {
      component: exclamationCircleIcon,
    },
    userIcon: {
      component: userIcon,
    },
    moneyBagIcon: {
      component: moneyBagIcon,
    },
    arrowRightIcon: {
      component: arrowRightIcon,
    },
    arrowLeftIcon: {
      component: arrowLeftIcon,
    },
    arrowDownIcon: {
      component: arrowDownIcon,
    },
    phoneIcon: {
      component: phoneIcon,
    },
    nophoneIcon: {
      component: nophoneIcon,
    },
    mailIcon: {
      component: mailIcon,
    },
    cpfIcon: {
      component: cpfIcon,
    },
    cakeIcon: {
      component: cakeIcon,
    },
    cartIcon: {
      component: cartIcon,
    },
    moneyCircleIcon: {
      component: moneyCircleIcon,
    },
    heartIcon: {
      component: heartIcon,
    },
    clockIcon: {
      component: clockIcon,
    },
    giftIcon: {
      component: giftIcon,
    },
    deleteIcon: {
      component: deleteIcon,
    },
    scaredEmojiIcon: {
      component: scaredEmojiIcon,
    },
    arrowSwapIcon: {
      component: arrowSwapIcon,
    },
    signOutIcon: {
      component: signOutIcon,
    },
    zipperLogoIcon: {
      component: zipperLogoIcon,
    },
    crmLogoIcon: {
      component: crmLogoIcon,
    },
    shoppingBagIcon: {
      component: shoppingBagIcon,
    },
    userPlusIcon: {
      component: userPlusIcon,
    },
    unionIcon: {
      component: unionIcon,
    },
    editIcon: {
      component: editIcon,
    },
    atSignIcon: {
      component: atSignIcon,
    },
    pIcon: {
      component: pIcon,
    },
    barCodeIcon: {
      component: barCodeIcon,
    },
    bagIcon: {
      component: bagIcon,
    },
    passwordLockIcon: {
      component: passwordLockIcon,
    },
    localActivityIcon: {
      component: localActivityIcon,
    },
    storeIcon: {
      component: storeIcon,
    },
    catalogueIcon: {
      component: catalogueIcon,
    },
    catalogueThinIcon: {
      component: catalogueThinIcon,
    },
    heartOutlineIcon: {
      component: heartOutlineIcon,
    },
    checkIcon: {
      component: checkIcon,
    },
    basketIcon: {
      component: basketIcon,
    },
  },
});
Vue.config.productionTip = false;
LogRocket.init('wc5usq/zipper-app');

LogRocket.getSessionURL((sessionURL) => {
  Sentry.configureScope((scope) => {
    scope.setExtra('sessionURL', sessionURL);
  });
});

new Vue({
  router,
  store,
  apolloProvider,
  render: (h) => h(App),
}).$mount('#app');
